import {AvailableVehicleCategory} from '../../../category/enum/available-vehicle-category.enum';

export class VehicleSearchFilterRequest {
  constructor(
    public readonly brand: string[] | null = null,
    public readonly model: string[] | null = null,
    public readonly category: AvailableVehicleCategory[] | null = null,
    public readonly vin: string | null = null,
    public readonly factoryNumber: string | null = null,
    public readonly documentNumber: number | null = null,
    public readonly keyNumber: number | null = null,
    public readonly registrationPlate: string | null = null,
    public readonly arrivalDateFrom: string | null = null,
    public readonly arrivalDateTo: string | null = null,
    public readonly releaseDateFrom: string | null = null,
    public readonly releaseDateTo: string | null = null
  ) {
  }
}
